import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import { Translate } from "react-redux-i18n";
import CreateAccountModal from "../Modals/CreateAccountModal"
import { updateCreateAccountModalState } from "../../Store/Modals/Actions";
Modal.setAppElement("#react-app");

class GuestAlert extends Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        this.props.updateCreateAccountModalState(true);
    }

    render() {
        return <div className="nav-container guest-alert">
            <div className="bar bar--sm">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <FontAwesomeIcon icon={faBell}/> <Translate value="guestAlert.desc1" /> <Link to="#" onClick={this.openModal} style={{ color: "#fff", fontWeight: 400, textDecoration: "underline" }}><Translate value="guestAlert.desc2" /></Link>
                        </div>
                    </div>
                </div>
            </div>
            <CreateAccountModal/>
        </div>;
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCreateAccountModalState: updateCreateAccountModalState
    }, dispatch);
}

export default withRouter(connect(null, mapDispatchToProps)(GuestAlert));